import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { NotificationFeedAnalyticsEffects } from './_state/notification-feed-analytics.effects';
import { NotificationFeedEffects } from './_state/notification-feed.effects';
import { NotificationFeedStateKey } from './_state/notification-feed.model';
import { NotificationFeedReducer } from './_state/notification-feed.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(NotificationFeedStateKey, NotificationFeedReducer),
    EffectsModule.forFeature([NotificationFeedEffects, NotificationFeedAnalyticsEffects]),
  ],
  exports: [],
})
export class NotificationFeedModule {}
